module.exports = __webpack_public_path__ + "static/media/instagram-stories-dancer.5668769d.mp4";